//=============================================
// ARCHELIOS MAP NAMESPACE
//=============================================
var am = (function(module) {

    //Use strict mode
    'use strict';

    /**
     * 
     */
    module.InfoPanelController = function() {
        // Private attributes
        this._mainPanelView = undefined; // reference to the main view associated with the controller
        this._roofPanelView = undefined; // reference to the small side view associated with the controller
        this._map  = undefined; // reference to the map
        this._config = {
            displayRoofPanel: true,
            displayShareWithAdministation: false,
            suppressGoFurtherSection: false,
            minRoofSurfaceForWaitingModal: 500,
            displayPdfGuidesOnLastPage: false,
            maxAllowedInstallationPower: 100,
            displaySentenceBelowSurfaceSlider: false,
            lastPanelPageEntries: {
                electricitySale: {
                    individual: 4,
                    professional: 4,
                    administration: 4
                },
                electricityAutoconsumption: {
                    individual: 4,
                    professional: 0,
                    administration: 0
                },
                hotWater: {
                    individual: 3,
                    professional: 0,
                    administration: 0
                }
            }
        };

        this._address = null;

        this._dataBindings = {
            dailyHotWaterProduction: {
                id: "dailyHotWaterProduction",
                unit: "L",
                precision: "0"
            },
            hotWaterProductionEquivalent: {
                id: "hotWaterProductionEquivalent",
                unit: "person",
                precision: "0"
            },
            maxAvailableRoof3DArea: {
                id: "maxAvailableRoof3DArea",
                unit: "m2",
                precision: "0"
            },
            annualElectricityProduction: {
                id: "annualElectricityProduction",
                unit: "kWhPerYear",
                precision: "-1"
            },
            annualElectricityConsumption: {
                id: "annualElectricityConsumption",
                unit: "kWhPerYear",
                precision: "-1"
            },
            electricityProductionEquivalent: {
                id: "electricityProductionEquivalent",
                unit: "person",
                precision: "0"
            },
            pvAnnualCO2Savings: {
                id: "pvAnnualCO2Savings",
                unit: "kg",
                precision: "-1"
            },
            thermalPanelAnnualCO2Savings: {
                id: "thermalPanelAnnualCO2Savings",
                unit: "kg",
                precision: "-1"
            },

            /**
             * SALE AREA
             */
            pvElecSaleBorrow: {
                id: "pvElecSaleBorrow",
                unit: "currency",
                precision: "-1"
            },
            pvElecSaleBorrowedPercentage: {
                id: "pvElecSaleBorrowedPercentage",
                unit: "%",
                precision: "0"
            },
            pvElecSaleYearlyIncome: {
                id: "pvElecSaleYearlyIncome",
                unit: "currencyPerYear",
                precision: "-1"
            },
            pvElecSaleTotalIncome: {
                id: "pvElecSaleTotalIncome",
                unit: "currency",
                precision: "-1"
            },
            pvElecSaleInstallationCost: {
                id: "pvElecSaleInstallationCost",
                unit: "currency",
                precision: "-2"
            },
            pvElecSaleTotalProfits: {
                id: "pvElecSaleTotalProfits",
                unit: "currency",
                precision: "-1"
            },
            pvElecSaleYearlyProfits: {
                id: "pvElecSaleYearlyProfits",
                unit: "currencyPerYear",
                precision: "-1"
            },
            pvElecSaleYearlyRawProfits: {
                id: "pvElecSaleYearlyRawProfits",
                unit: "currencyPerYear",
                precision: "-1"
            },
            pvElecSaleYearlyOwnFunds: {
                id: "pvElecSaleYearlyOwnFunds",
                unit: "currencyPerYear",
                precision: "-1"
            },
            pvElecSaleYearlyCreditLoan: {
                id: "pvElecSaleYearlyCreditLoan",
                unit: "currencyPerYear",
                precision: "-1"
            },
            pvElecSaleYearlyMaintenance: {
                id: "pvElecSaleYearlyMaintenance",
                unit: "currencyPerYear",
                precision: "-1"
            },
            pvElecSaleReturnOnInvestment: {
                id: "pvElecSaleReturnOnInvestment",
                unit: "year",
                precision: "0"
            },
            pvElecSaleSubventions: {
                id: "pvElecSaleSubventions",
                unit: "currency",
                precision: "-1"
            },
            pvElecSaleTotalMaintenance: {
                id: "pvElecSaleTotalMaintenance",
                unit: "currency",
                precision: "-1"
            },
            pvElecSaleTotalCreditLoan: {
                id: "pvElecSaleTotalCreditLoan",
                unit: "currency",
                precision: "-1"
            },
            pvElecSaleOwnFunds: {
                id: "pvElecSaleOwnFunds",
                unit: "currency",
                precision: "-1"
            },
            pvElecSaleRaccordement: {
                id: "pvElecSaleRaccordement",
                unit: "currency",
                precision: "-1"
            },
            pvElecSaleInstallWoRaccordement: {
                id: "pvElecSaleInstallWoRaccordement",
                unit: "currency",
                precision: "-1"
            },
            electricityAutoproductionPercentage: {
                id: "electricityAutoproductionPercentage",
                unit: "%",
                precision: "0"
            },
            pvElecSaleObservationPeriod: {
                id: "pvElecSaleObservationPeriod",
                unit: "year",
                precision: "0"
            },

            /**
             * AUTOCONSO AREA
             */
            pvAutoconsoInstallationCost: {
                id: "pvAutoconsoInstallationCost",
                unit: "currency",
                precision: "-2"
            },
            pvAutoconsoBorrowedPercentage: {
                id: "pvAutoconsoBorrowedPercentage",
                unit: "%",
                precision: "0"
            },
            pvAutoconsoBorrow: {
                id: "pvAutoconsoBorrow",
                unit: "currency",
                precision: "-2"
            },
            pvAutoconsoSavings: {
                id: "pvAutoconsoSavings",
                unit: "currencyPerYear",
                precision: "-1"
            },
            pvAutoconsoTotalSavings: {
                id: "pvAutoconsoTotalSavings",
                unit: "currency",
                precision: "-1"
            },
            pvAutoconsoIncome: {
                id: "pvAutoconsoIncome",
                unit: "currencyPerYear",
                precision: "-1"
            },
            pvAutoconsoTotalIncome: {
                id: "pvAutoconsoTotalIncome",
                unit: "currency",
                precision: "-1"
            },
            pvAutoconsoTotalProfits: {
                id: "pvAutoconsoTotalProfits",
                unit: "currency",
                precision: "-1"
            },
            pvAutoconsoReturnOnInvestment: {
                id: "pvAutoconsoReturnOnInvestment",
                unit: "year",
                precision: "0"
            },
            pvAutoconsoSubventions: {
                id: "pvAutoconsoSubventions",
                unit: "currency",
                precision: "-1"
            },
            pvAutoconsoTotalMaintenance: {
                id: "pvAutoconsoTotalMaintenance",
                unit: "currency",
                precision: "-1"
            },
            pvAutoconsoTotalCreditLoan: {
                id: "pvAutoconsoTotalCreditLoan",
                unit: "currency",
                precision: "-1"
            },
            pvAutoconsoOwnFunds: {
                id: "pvAutoconsoOwnFunds",
                unit: "currency",
                precision: "-1"
            },
            pvAutoconsoRaccordement: {
                id: "pvAutoconsoRaccordement",
                unit: "currency",
                precision: "-1"
            },
            pvAutoconsoInstallWoRaccordement: {
                id: "pvAutoconsoInstallWoRaccordement",
                unit: "currency",
                precision: "-1"
            },
            pvAutoconsoYearlyIncome: {
                id: "pvAutoconsoYearlyIncome",
                unit: "currencyPerYear",
                precision: "-1"
            },
            pvAutoconsoYearlySavings: {
                id: "pvAutoconsoYearlySavings",
                unit: "currencyPerYear",
                precision: "-1"
            },
            pvAutoconsoYearlyProfits: {
                id: "pvAutoconsoYearlyProfits",
                unit: "currencyPerYear",
                precision: "-1"
            },
            pvAutoconsoYearlyRawProfits: {
                id: "pvAutoconsoYearlyRawProfits",
                unit: "currencyPerYear",
                precision: "-1"
            },
            pvAutoconsoYearlyOwnFunds: {
                id: "pvAutoconsoYearlyOwnFunds",
                unit: "currencyPerYear",
                precision: "-1"
            },
            pvAutoconsoYearlyCreditLoan: {
                id: "pvAutoconsoYearlyCreditLoan",
                unit: "currencyPerYear",
                precision: "-1"
            },
            pvAutoconsoYearlyMaintenance: {
                id: "pvAutoconsoYearlyMaintenance",
                unit: "currencyPerYear",
                precision: "-1"
            },
            pvAutoconsoObservationPeriod: {
                id: "pvAutoconsoObservationPeriod",
                unit: "year",
                precision: "0"
            },
            
            /**
             * THERMAL PANEL AREA
             */
            thermalPanelSurface: {
                id: "thermalPanelSurface",
                unit: "m2",
                precision: "0"
            },
            thermalPanelAnnualNeedsCoveragePercentage: {
                id: "thermalPanelAnnualNeedsCoveragePercentage",
                unit: "%",
                precision: "0"
            },
            thermalPanelInstallationCost: {
                id: "thermalPanelInstallationCost",
                unit: "currency",
                precision: "-2"
            },
            thermalPanelRawInstallationCost: {
                id: "thermalPanelRawInstallationCost",
                unit: "currency",
                precision: "-2"
            },
            thermalPanelSubventions: {
                id: "thermalPanelSubventions",
                unit: "currency",
                precision: "-1"
            },
            thermalTotalMaintenance: {
                id: "thermalTotalMaintenance",
                unit: "currency",
                precision: "-1"
            },
            thermalTotalCreditLoan: {
                id: "thermalTotalCreditLoan",
                unit: "currency",
                precision: "-1"
            },
            thermalPanelOwnFunds: {
                id: "thermalPanelOwnFunds",
                unit: "currency",
                precision: "-1"
            },
            thermalPanelBorrow: {
                id: "thermalPanelBorrow",
                unit: "currency",
                precision: "-1"
            },
            thermalPanelBorrowedPercentage: {
                id: "thermalPanelBorrowedPercentage",
                unit: "%",
                precision: "0"
            },
            thermalPanelReturnOnInvestment: {
                id: "thermalPanelReturnOnInvestment",
                unit: "year",
                precision: "0"
            },
			thermalPanelYearlySavings: {
                id: "thermalPanelYearlySavings",
                unit: "currencyPerYear",
                precision: "-1"
            },
            thermalPanelTotalBillSavings: {
                id: "thermalPanelTotalBillSavings",
                unit: "currency",
                precision: "-1"
            },
            thermalPanelTotalSavings: {
                id: "thermalPanelTotalSavings",
                unit: "currency",
                precision: "-1"
            },
            thermalPanelTotalSpendings: {
                id: "thermalPanelTotalSpendings",
                unit: "currency",
                precision: "-1"
            },
            thermalPanelTotalMaintenance: {
                id: "thermalPanelTotalMaintenance",
                unit: "currency",
                precision: "-1"
            },
            thermalPanelTotalCreditLoan: {
                id: "thermalPanelTotalCreditLoan",
                unit: "currency",
                precision: "-1"
            },
            thermalPanelTotalCreditCost: {
                id: "thermalPanelTotalCreditCost",
                unit: "currency",
                precision: "-1"
            },
            thermalPanelTotalProfits: {
                id: "thermalPanelTotalProfits",
                unit: "currency",
                precision: "-1"
            },
            thermalPanelRawTotalProfits: {
                id: "thermalPanelRawTotalProfits",
                unit: "currency",
                precision: "-1"
            },
            thermalPanelYearlyIncome: {
                id: "thermalPanelYearlyIncome",
                unit: "currencyPerYear",
                precision: "-1"
            },
            thermalPanelYearlyProfits: {
                id: "thermalPanelYearlyProfits",
                unit: "currencyPerYear",
                precision: "-1"
            },
            thermalPanelYearlyOwnFunds: {
                id: "thermalPanelYearlyOwnFunds",
                unit: "currencyPerYear",
                precision: "-1"
            },
            thermalPanelYearlyRawProfits: {
                id: "thermalPanelYearlyRawProfits",
                unit: "currencyPerYear",
                precision: "-1"
            },
            thermalPanelYearlyCreditLoan: {
                id: "thermalPanelYearlyCreditLoan",
                unit: "currencyPerYear",
                precision: "-1"
            },
            thermalPanelYearlySpendings: {
                id: "thermalPanelYearlySpendings",
                unit: "currencyPerYear",
                precision: "-1"
            },
            thermalPanelYearlyMaintenance: {
                id: "thermalPanelYearlyMaintenance",
                unit: "currencyPerYear",
                precision: "-1"
            },
            thermalPanelYearlyInvestment: {
                id: "thermalPanelYearlyInvestment",
                unit: "currencyPerYear",
                precision: "-1"
            },
            thermalPanelObservationPeriod: {
                id: "thermalPanelObservationPeriod",
                unit: "year",
                precision: "0"
            },
            
            /**
             * COMBINED PANEL AREA
             */
			combinedPanelSurface: {// #2963
                id: "combinedPanelSurface",
                unit: "m2",
                precision: "0"
            },
            combinedAnnualHotWaterNeedsCoverageRate: {// #2963
                id: "combinedAnnualHotWaterNeedsCoverageRate",
                unit: "%",
                precision: "0"
            },
            combinedAnnualHeatNeedsCoverageRate: {// #2963
                id: "combinedAnnualHeatNeedsCoverageRate",
                unit: "%",
                precision: "0"
            },
            combinedInstallationCost: {// #2963
                id: "combinedInstallationCost",
                unit: "currency",
                precision: "-2"
            },
            combinedRawInstallationCost: {// #2963
                id: "combinedRawInstallationCost",
                unit: "currency",
                precision: "-2"
            },
            combinedSubventions: {
                id: "combinedSubventions",
                unit: "currency",
                precision: "-1"
            },
            combinedTotalMaintenance: {
                id: "combinedTotalMaintenance",
                unit: "currency",
                precision: "-1"
            },
            combinedTotalCreditLoan: {
                id: "combinedTotalCreditLoan",
                unit: "currency",
                precision: "-1"
            },
            combinedOwnFunds: {
                id: "combinedOwnFunds",
                unit: "currency",
                precision: "-1"
            },
            combinedBorrow: {// #2963
                id: "combinedBorrow",
                unit: "currency",
                precision: "-1"
            },
            combinedBorrowedPercentage: {// #2963
                id: "combinedBorrowedPercentage",
                unit: "%",
                precision: "0"
            },
            combinedYearlySavings: {// #2963
                id: "combinedYearlySavings",
                unit: "currencyPerYear",
                precision: "-1"
            },
            combinedTotalSavings: {// #2963
                id: "combinedTotalSavings",
                unit: "currency",
                precision: "-1"
            },
            combinedTotalProfits: {// #2963
                id: "combinedTotalProfits",
                unit: "currency",
                precision: "-1"
            },
            combinedReturnOnInvestment: {// #2963
                id: "combinedReturnOnInvestment",
                unit: "year",
                precision: "0"
            },
            combinedYearlyIncome: {
                id: "combinedYearlyIncome",
                unit: "currencyPerYear",
                precision: "-1"
            },
            combinedYearlyProfits: {
                id: "combinedYearlyProfits",
                unit: "currencyPerYear",
                precision: "-1"
            },
            combinedYearlyRawProfits: {
                id: "combinedYearlyRawProfits",
                unit: "currencyPerYear",
                precision: "-1"
            },
            combinedYearlyOwnFunds: {
                id: "combinedYearlyOwnFunds",
                unit: "currencyPerYear",
                precision: "-1"
            },
            combinedYearlyCreditLoan: {
                id: "combinedYearlyCreditLoan",
                unit: "currencyPerYear",
                precision: "-1"
            },
            combinedYearlySpendings: {
                id: "combinedYearlySpendings",
                unit: "currencyPerYear",
                precision: "-1"
            },
            combinedYearlyMaintenance: {
                id: "combinedYearlyMaintenance",
                unit: "currencyPerYear",
                precision: "-1"
            },
            combinedYearlyInvestment: {
                id: "combinedYearlyInvestment",
                unit: "currencyPerYear",
                precision: "-1"
            },
            combinedObservationPeriod: {
                id: "combinedObservationPeriod",
                unit: "year",
                precision: "0"
            },
            optimalSurfaceForElectricitySale: {
                id: "optimalSurfaceForElectricitySale",
                unit: "m2",
                precision: "0"
            },
            optimalPeakPowerForElectricitySale: {
                id: "optimalPeakPowerForElectricitySale",
                unit: "kWc",
                precision: "1"
            },
            optimalSurfaceForAutoconsumption : {
                id: "optimalSurfaceForAutoconsumption",
                unit: "m2",
                precision: "0"
            },
            optimalPeakPowerForAutoconsumption : {
                id: "optimalPeakPowerForAutoconsumption",
                unit: "kWc",
                precision: "1"
            }
        };

        this._handleFormChange = undefined;
        this._handlePageChange = undefined;
        this._updateCheckbox = undefined;
        this._closePanel = undefined;
        this._irradiationClasses = [];
    };

    module.InfoPanelController.prototype.init = function(mainController, config) {

        var appConfig = mainController.getConfig();
        var irradiationClasses = am.utils.getIrradClasses(appConfig);
        var maxReturnOnInvestment = (appConfig.maxReturnOnInvestment === undefined) ? 20 : appConfig.maxReturnOnInvestment;
        
        // Instantiate the private attributes
        this._config = am.utils.mergeObjects(this._config, config);
        this._address = mainController.address;

        this._config.projectId = appConfig.projectId;

        this._map  = mainController.getMapObject();
        this._irradiationClasses = irradiationClasses;
        this._mainPanelView = am.utils.infoPanelView({
            anchor: 'lower-right',
            autoPan: false,
            customCssClass: 'am-main-panel',
            templateParameters: {
                irradiationClasses: irradiationClasses,
                lastPageEntries: this._config.lastPanelPageEntries,
                addShareButton: this._config.displayShareWithAdministation,
                showMessageBelowEconomicalResults: this._config.displayMessageBelowEconomicalResults,
                displayResultsSentencePrefix: this._config.displayResultsSentencePrefix,
                suppressGoFurtherSection: this._config.suppressGoFurtherSection,
                displayPDFGuidesOnLastPage: this._config.displayPdfGuidesOnLastPage,
                displaySentenceBelowSurfaceSlider: this._config.displaySentenceBelowSurfaceSlider
            },
            maxROIForProfitability: maxReturnOnInvestment
        }).addTo(this._map);
        if (this._config.displayRoofPanel) {
            this._roofPanelView = am.utils.panelView({
                anchor: 'lower-left',
                autoPan: false,
                customCssClass: 'am-roof-info-panel'
            }).addTo(this._map);
        }

        // Register event handlers associated with the main panel view
        this._initializeMainPanelView();

        // Populate the small side panel displaying information on the selected roof (surface, potential, etc.) and attach event handlers to it
        this._initializeRoofPanelView();

        // Register event handlers associated with the panel
        am.eventManager.register('display_info_on_feature', this._displayInfoOnFeature, this);
        am.eventManager.register('feature_selection_changed', this._updateSlider, this);
        am.eventManager.register('hide_feature_info', this._hideFeatureInfo, this);
        am.eventManager.register('roof_irradiation_computation_started', this._handleComputationStart, this);
        am.eventManager.register('roof_irradiation_computation_ended', this._handleComputationEnd, this);
        am.eventManager.register('address_search_field_updated', this._setAddress, this);
    };

    module.InfoPanelController.prototype.destroy = function() {
        // Remove panel from the map
        this._mainPanelView.remove();
        this._map = undefined;

        // Remove event handlers associated with the view
        var _this = this;
        this._mainPanelView.getPanel().then(function(panelElement) {
            panelElement.find('.input, .checkbox').off('click tap', _this._updateCheckbox);
            panelElement.find('input').off('change', _this._handleFormChange);
            panelElement.find('a.btn, button:not(.btn-close)').off('click tap', _this._handlePageChange);
            panelElement.find('.am-solar-panel-surface-slider').off('slide change', _this._handleFormChange);
            panelElement.find('.am-solar-panel-surface-slider').off('slide change', _this._limitSliderRange);
            panelElement.find('.am-solar-panel-surface-slider').off('slide change', _this._displayWaitModal);
            panelElement.find('.btn-close').off('click tap', _this._closePanel);
            panelElement.find('.btn-share').off('click tap', _this._displayShareModal);
            panelElement.find('#am-user-profiles label').off('click tap', _this._toggleSimulationButtons);
        });

        // Remove event handlers associated with the panel
        am.eventManager.unregister('knob_changed', this._handleFormChange, this);
        am.eventManager.unregister('display_info_on_feature', this._displayInfoOnFeature, this);
        am.eventManager.unregister('feature_selection_changed', this._updateSlider, this);
        am.eventManager.unregister('hide_feature_info', this._hideFeatureInfo, this);
        am.eventManager.unregister('address_search_field_updated', this._setAddress, this);
    };

    module.InfoPanelController.prototype._initializeMainPanelView = function() {
        var _this = this;
        this._mainPanelView.getPanelElement().then(function(panelElement) {
            // Define the function called to synchronize the form elements (if one element is changed, the same 
            // elements in the other forms are set to the same value; this is also true for the sliders)
            _this._handleFormChange = function(event) {

                return new Promise(function(resolve, reject) {
                    // Synchronize the various form elements
                    if (event.type == "knob_changed") {
                        resolve();
                    } else {
                        var $target = $(event.target).closest('.am-user-input').find('input');
                        if ($target.attr('data-provide') == 'slider') { // slider
                            _this._mainPanelView.getSliderElements().then(function (sliders) {
                                sliders.forEach(function (slider) {
                                    slider.bootstrapSlider('setValue', $target.val(), false, false);
                                    slider.updatePeakPower();
                                    slider.bootstrapSlider('relayout');
                                });
                                resolve();
                            });
                        } else { // number or checkbox
                            var targetType = $target.attr('type');
                            var targetName = $target.attr('name');
                            var sameElementsSelector = 'input[type="' + targetType + '"][name="' + targetName + '"]';
                            var $sameElements = panelElement.find(sameElementsSelector);
                            if (targetType == 'checkbox') {
                                $sameElements.prop('checked', $target.prop('checked'));
                                if ($target.attr('checked') && ($target.attr('checked') == 'checked')) {
                                    $sameElements.attr('checked', 'checked');
                                } else {
                                    $sameElements.removeAttr('checked');
                                }
                            } else if (targetType == 'number') {
                                $sameElements.val($target.val());
                            }
                            resolve();
                        }
                    }
                }).then(function(res) {
                    return _this._updateResults();
                }).then(function (res) {
					var $target = $(event.target).closest('.am-user-input').find('input');
					var targetName = $target.attr('name');
					if(targetName=="thermalType")// #2963
                        _this._mainPanelView.updateThermalView($target.val());
                    // Send en event to notify the main controller that the address displayed in the browser navigation bar
                    // should be changed
                    am.eventManager.trigger('update_url', _this._getPageUrl());
                }); // #2381
            }


            // Define the function changing the current page after the user has clicked on a link button
            _this._handlePageChange = function(event) {
                // Change the current page
                var $target = $(event.target).closest('button');
                var newPageId = $target.attr('data-target');
                var oldPageId = _this._mainPanelView.getCurrentPageId();
                if (newPageId) { // display the requested page only if it belongs to the current panel
                    _this._mainPanelView.displayPage(newPageId);
                }

                // Send en event to notify the main controller that the address displayed in the browser navigation bar
                // should be changed
                am.eventManager.trigger('update_url', _this._getPageUrl(oldPageId, newPageId));
                am.eventManager.trigger('tracking_click', $target[0].id); // #2747 suivi des clics, on envoie l'id du bouton cliqué

            };

            // Update the input checkboxes when the user clicks on the associated div
            _this._updateCheckbox = function(event) {
                event.preventDefault();
                if ($(this).hasClass('checkbox')) {
                    var $input = $(this).find('input');
                    $input.prop('checked', !$input.prop('checked'));
                    if ($input.attr('checked') && ($input.attr('checked') == 'checked')) {
                        $input.removeAttr('checked');
                    } else {
                        $input.attr('checked', 'checked');
                    }
                    event.target = $input.get(0);
                }
                _this._handleFormChange(event);
            };

            // Close panel
            _this._closePanel = function(event) {
                _this._hideFeatureInfo();
                am.eventManager.trigger('clear_feature_selection');
            };

            // Disable thermal simulation and autoconsumption buttons in the case of a professional or an administration
            _this._toggleSimulationButtons = function(event) {
                // Get the radio button on which the user clicked 
                var $input = $(event.target).closest('label').find('input');
                var choice = $input.attr('value');

                // Handle the display of the right content depending on the user type (individual, professional, administration)
                $(event.target).closest('.page').find('.update-trans').each(function() {
                    // Show the right content and hide the others
                    $( this ).find( '[data-trans-type]:not([data-trans-type~="' + choice + '"])').addClass('hidden');
                    $( this ).find( '[data-trans-type~="' + choice + '"]').removeClass('hidden');
                });
                var $pageContents = $(event.target).closest('.page-content');
                $pageContents.animate({ scrollTop: $pageContents.outerHeight() }, 800); // scroll smoothly to the bottom of the page

                // (De)activate the buttons
                var buttons = [$('#btn_am-hot-water-info-section'), $('#btn_am-autoconsumption-info-section')];
                if (choice === "individual") {
                    buttons.forEach(function($button) {
                        $button.prop('disabled', false);
                    });
                } else { // professional or administration
                    buttons.forEach(function($button) {
                        $button.prop('disabled', true);
                    });
                }
            };

            // Fill the "share" modal window
            var $shareModalContainer = $('#am-share-modal');
            am.templateManager.fillElementWithTemplate($shareModalContainer, 'share-modal', {}, function($container){
                var $modalContents = $container.find("#am-share-modal-contents");
                $modalContents.modal({
                    backdrop: 'static',
                    show: false
                });

                var $copyLinkButton = $modalContents.find('.btn[data-action="copy-link"]');
                $copyLinkButton.on('click tap', function() {
                    $modalContents.find('#am-link-to-project').get(0).select();
                    document.execCommand("Copy");
                    $copyLinkButton.find('.am-icon').removeClass('am-copy-icon').addClass('am-valid-icon');
                });

                var $exportPDFButton = $modalContents.find('.btn[data-action="export-pdf"]');
                $exportPDFButton.on('click tap', function() {
                    // console.log('clicked on export pdf');

                    // Disable modal buttons
                    $('#am-share-modal-contents .btn').addClass('disabled');
                    $('body').addClass('global-loading');

                    // Load scripts to generate the PDF
                    // var scriptsToLoad = ['/vendors/pdfkit/pdfkit.js', '/vendors/pdfkit/blob-stream.js', '/vendors/pdfkit/pdfReport.js'];
                    var scriptsToLoad = ['/vendors/pdfkit/pdfkit.js', '/vendors/pdfkit/blob-stream.js', '/vendors/pdfkit/svgtopdf.js'];
                    var loadScriptPromises = scriptsToLoad.map(function(script) {
                        return $.ajax({
                            url: script,
                            dataType: "script",
                            error: function(jqXHR, textStatus, errorThrown) {
                                console.error('Cannot load script ' + script + ': ' + textStatus);
                            }
                        });
                    });

                    // console.log(am.solarInstallationModel.getResult('roofExtents'));
                    var _map = _this._map;

                    am.solarInstallationModel.getResults().then(function(results) {
                        var oRoofExt = results.roofExtents;
                        var lowerLeftPoint  = _map.latLngToContainerPoint(L.latLng(oRoofExt.lowerLeftCorner[1], oRoofExt.lowerLeftCorner[0]));
                        var upperRightPoint = _map.latLngToContainerPoint(L.latLng(oRoofExt.upperRightCorner[1], oRoofExt.upperRightCorner[0]));
                        var width  = Math.abs(upperRightPoint.x - lowerLeftPoint.x);
                        var height = Math.abs(upperRightPoint.y - lowerLeftPoint.y);
                        var halfSide = 0.5 * Math.max(width, height); // we take a square picture
                        var upperLeftPoint = [
                            0.5 * (lowerLeftPoint.x + upperRightPoint.x) - halfSide,
                            0.5 * (lowerLeftPoint.y + upperRightPoint.y) - halfSide
                        ];

                        Promise.all(loadScriptPromises).then(function() {/*
                            return html2canvas(document.getElementById('map'), {
                                // allowTaint: true,
                                backgroundColor: null,
                                // removeContainer: false
                                x: upperLeftPoint[0] - 10,
                                y: upperLeftPoint[1] - 10,
                                width: 2 * halfSide + 20,
                                height: 2 * halfSide + 20
                            });
                        }).then(function(canvas) {*/
                            var inputs = _this._mainPanelView.getUserInputs();

                            // Build the object to be passed to the PDF template
                            var data = {};
                            Object.keys(_this._dataBindings).forEach(function(key) {
                                data[key] = _this._mainPanelView.formatComputationResult(results, _this._dataBindings[key]).value;
                            });

                            data.currSimulationType = (function(currPageId) {
                                if (currPageId.indexOf("autoconsumption") !== -1) return "electricitySelfConsumption";
                                else if (currPageId.indexOf("hot-water") !== -1)  return "hotWaterProduction";
                                else                                              return "electricityProduction";
                            })(_this._mainPanelView.getCurrentPageId());

                            var splitIndex = _this._address.search(/[^\d](\d{5,})/); // use the postal code as separator
                            data.postalAddress = [
                                _this._address.substring(0, splitIndex),
                                _this._address.substring(splitIndex + 1) // we do not capture the comma or space
                            ];

                            //data.roofImageData = canvas.toDataURL("image/jpeg"); // toDataURL defaults to png, so we need to request a jpeg, then convert for file download.
                            data.surfacePerIrradiationClass = results.surfacePerIrradiationClass.map(function(val) {return Math.round(val); });
                            data.totalRoofSurface = Math.round(results.roof3DArea);
                            data.pvInstallationSurface = Math.round(inputs.usedRoofArea);
                            data.thermalInstallationSurface = Math.round(inputs.thermalPanelSurface);
                            data.nbEtages = inputs.numberOfFloors; // nb etages
                            data.nbPersonnes = inputs.numberOfInhabitants;
                            data.chauffageElectrique = inputs.hasElectricalHeating; //
                            data.chauffeEauElectrique = inputs.hasElectricalBoiler;
                            data.currentUrl = window.location.href;
                            data.dateCourante = new Date().toLocaleDateString(undefined, {
                                day: "numeric",
                                month: "long",
                                year: "numeric"
                            });

                            _this._exportPDFAction(data);

                            // Re-enable modal buttons
                            $('#am-share-modal-contents .btn').removeClass('disabled');
                            $('body').removeClass('global-loading');
                        });
                    });
                });

                var $reportRequestForm = $modalContents.find('#reportRequestForm');
                $reportRequestForm.on('submit', function(event) {
                    event.preventDefault();

                    // Get the form values as a plain JS object
                    var formValues = {};
                    $reportRequestForm.serializeArray().forEach(function(element) {
                        formValues[element.name] = element.value;
                    });

                    // Construct the body of the email
                    var emailBody = am.translator.translate('reportRequestEmailBody')
                        .replace('[[FIRST-NAME]]', formValues.firstName)
                        .replace('[[FAMILY-NAME]]', formValues.familyName)
                        .replace('[[PHONE-NUMBER]]', formValues.phoneNumber)
                        .replace('[[EMAIL-ADDRESS]]', formValues.emailAddress)
                        .replace('[[LINK]]', window.location.href);

                    if (formValues.okToSendCoordinates == "on") {
                      $.ajax({
                        //dataType: 'json',
                        data: {
                          "mail_to": am.translator.translate('reportRequestTo'),
                          "first_name": formValues.firstName,
                          "last_name": formValues.familyName,
                          "phone_number": formValues.phoneNumber,
                          "prospect_mail":  formValues.emailAddress,
                          "prospect_link": window.location.href,
                          "subject": am.translator.translate('reportRequestEmailSubject'),
                          "body": emailBody
                        },
                        type: "POST",
                        url: "/backend/processRequest.php",
                        success: function(msg) {
                          var $modalContents = $shareModalContainer.find("#am-share-modal-contents"),
                              $sendLinkButton = $modalContents.find('.btn-call-to-action');
                          $sendLinkButton.html(am.translator.translate(msg));
                          $sendLinkButton.prop('disabled', true);
                        },
                        error: function(msg,stat, settings) {
                          console.log("Error send mail : ", msg, settings);
                        }
                      });
                    } else {
                        am.utils.displayMessageNextToElement($(this).find('button[type="submit"]'), 'error-message', {
                            message: am.translator.translate('youMustAgreeToContinue')
                        }, 'bottom', {
                            customClass: 'am-dropdown-error-message',
                            duration: 3000,
                            width: 'inherit'
                        });
                    }
                });
            });

            _this._exportPDFAction = function(results) {
                // Choose the right PDF template
                var pdfTemplate = "";
                switch(results.currSimulationType) {
                    case 'electricityProduction':
                        pdfTemplate = 'pdf-report-elec-sale';
                        break;
                    case 'electricitySelfConsumption':
                        pdfTemplate = 'pdf-report-elec-autoconso';
                        break;
                    case 'hotWaterProduction':
                        pdfTemplate = 'pdf-report-thermal';
                        break;
                    default:
                        throw new Error("Unknown simulation type '" + results.currSimulationType + "'");
                }

                // Fetch the template and convert it to PDF
                am.templateManager.getTemplateAsText(pdfTemplate, results).then(function(svgContents) {
                    // Open PDF document
                    var doc = new PDFDocument({ layout: "portrait", size: "A4" });

                    // Fill the PDF document
                    SVGtoPDF(doc, svgContents, 0, 0);

                    // Sauvegarde le document sous forme de fichier
                    var stream = doc.pipe(blobStream());
                    stream.on('finish', function(fd) {
                        var url = stream.toBlobURL('application/pdf');

                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.href = url;
                        a.download = "rapport.pdf";
                        a.click();
                        document.body.removeChild(a);
                    });

                    // Close PDF document
                    doc.end();
                });
            };

            // Display the "share" modal window
            _this._displayShareModal = function(event) {
                var $modalContents = $shareModalContainer.find("#am-share-modal-contents");
                var link = window.location.href;
                $modalContents.find('#am-link-to-project').val(link);
                $modalContents.find('.btn[data-action="copy-link"] .am-icon').removeClass('am-valid-icon').addClass('am-copy-icon');
                var $sendLinkButton = $modalContents.find('.btn[data-action="send-link"]');
                if ($sendLinkButton.length > 0) {
                    var href = $sendLinkButton.attr('href');
                    $sendLinkButton.attr('href', href.replace('[[LINK]]', encodeURIComponent(link)));
                }

                // var $sendRequest = $modalContents.find('.btn-call-to-action');
                // $sendRequest.html(am.translator.translate('sendRequest'));
                // $sendRequest.prop('disabled', false);

                $modalContents.modal("show");
            };

            // Replace place holders with their respective contents
            _this._setHrefInContactButton = function(event) {
                var $element = $(event.target).closest('a');
                var href = $element.attr('href');
                var hrefBackup = href;
                var currUrl = window.location;
                var urlParts = am.utils.getUrlParameters(currUrl.search);
                if (urlParts.hasOwnProperty('panelPageId') && urlParts.hasOwnProperty('previousPanelPageId')) {
                    urlParts.panelPageId = urlParts.previousPanelPageId;
                    delete urlParts.previousPanelPageId;
                }
                href = href.replace('[[LINK]]', encodeURIComponent(currUrl.origin + currUrl.pathname + '?' + am.utils.combineUrlParameters(urlParts)));
                href = href.replace('[[ADDRESS]]', encodeURIComponent($(".am-address").text().trim()));
                $element.attr('href', href);
                setTimeout(function() { // restore initial state for next call
                    $element.attr('href', hrefBackup);
                }, 500);
            };

            // Color the div's displaying the solar potential classes
            am.utils.colorSolarPotentialDivs(panelElement, null, _this._irradiationClasses);

            panelElement.find('.input, .checkbox').on('click tap', _this._updateCheckbox);
            panelElement.find('input:not(.am-solar-panel-surface-slider)').on('change', function(e) {
                _this._handleFormChange(e);
            });
            panelElement.find('.am-solar-panel-surface-slider').on('slide change', function(e) {
                _this._handleFormChange(e);
            });
            panelElement.find('.am-solar-panel-surface-slider').on('slide change', _this._limitSliderRange);
            panelElement.find('.am-solar-panel-surface-slider').on('slide change', _this._displayWaitModal);
            panelElement.find('button:not(.btn-close)').on('click tap', _this._handlePageChange);//#2414 not(.btn-close) pour ne pas lancer un calcul inutile a la fermeture 
            panelElement.find('.btn-close').on('click tap', _this._closePanel);
            panelElement.find('.btn-share').on('click tap', _this._displayShareModal);
            panelElement.find('#am-user-profiles label').on('click tap', _this._toggleSimulationButtons);
            panelElement.find('.am-contact-administration').on('click tap', _this._setHrefInContactButton);

            am.eventManager.register('knob_changed', function(e) {
                _this._handleFormChange(e);
            }, _this);
        });
    };

    module.InfoPanelController.prototype._initializeRoofPanelView = function() {
        var self = this;
        if (this._config.displayRoofPanel) {
            am.templateManager.getTemplateAsHTMLElements('small-side-panel', {
                irradiationClasses : self._irradiationClasses,
                displayPublicFooter: false,
                compactForm: true
            }).then(function(htmlElements) {
                self._roofPanelView.setContents(htmlElements[0]);
                am.utils.colorSolarPotentialDivs($(self._roofPanelView.getContainer()), "to top", self._irradiationClasses);
            });
        }
    };

    module.InfoPanelController.prototype._displayInfoOnFeature = function(featureInfos) {
        var _this = this;

        var promise = new Promise(function(resolve, reject) {
            // Update the panel contents
            if (am.utils.isParameterInUrl('panelPageId')) {
                var urlParams = am.utils.getUrlParameters();
                _this._mainPanelView.setUserInputs(urlParams).then(function () {
                    _this._updateResults().then(function(res) {
                        _this._mainPanelView.displayPage(urlParams.panelPageId, urlParams.previousPanelPageId);
                        resolve(res);
                    });
                });
            } else if (featureInfos.reinitializePanel) {
                _this._updateResults().then(function(res) { // first round of computations to get the optimal surface
                    _this._mainPanelView.displayPage("am-home-section");
                    var userInputs = _this._mainPanelView.getUserInputs();
                    userInputs.usedRoofArea = res.optimalSurfaceForElectricitySale;
                    _this._mainPanelView.setUserInputs(userInputs).then(function () {
                        _this._updateResults().then(function(res2) { // second round of computations to set the optimal surface
                            resolve(res2);
                        });
                    });
                });
            } else {
                _this._updateResults().then(function(res) {
                    resolve(res);
                });
            }
        });
        promise.then(function(results) {
            // Update the slider limits
            _this._updateSlider(true, !am.utils.isParameterInUrl('panelPageId'), results);

            // Set the dimensions of the div's
            var sliderMinValue = results.minAvailableRoof3DArea;
            var sliderMaxValue = results.maxAvailableRoof3DArea;
            var surfaces = results.surfacePerIrradiationClass.slice(); // shallow copy of array
            var cumulatedSurface = 0;
            for (var iSurf = surfaces.length - 1; iSurf >= 0; --iSurf) {
                var newCumulatedSurface = cumulatedSurface + surfaces[iSurf];
                if (cumulatedSurface < sliderMinValue) {
                    surfaces[iSurf] = Math.max(0, newCumulatedSurface - sliderMinValue);
                }
                if (newCumulatedSurface > sliderMaxValue) {
                    surfaces[iSurf] = Math.max(0, sliderMaxValue - cumulatedSurface);
                }
                cumulatedSurface = newCumulatedSurface;
            }
            var availableRoofArea = surfaces.reduce(function(a, b) {return a + b;});
            var $panelElement = $(_this._mainPanelView.getContainer());
            var nBreaks = surfaces.length - 1;
            $panelElement.find('.am-surface-block-wrapper').each(function(unusedParam, wrapper) {
                $(wrapper).find('.am-surface-block').each(function(index, element) {
                    var width = surfaces[nBreaks - index] / availableRoofArea * 100;
                    var $element = $(element);
                    if (width < 1e-10) {
                        $element.hide();
                    } else {
                        $element.css('flex', width + '');
                        $element.show();
                    }
                });
            });

            // Display the warning about the architectural constraints
            if (results.hasOwnProperty("architecturalConstraints") && results.architecturalConstraints !== undefined) {
                if (results.architecturalConstraints > 0) {
                    $("#am-architectural-constraints-warning-block").removeClass("hidden");
                } else {
                    $("#am-architectural-constraints-warning-block").addClass("hidden");
                }
            }

            // display the panel
            _this._mainPanelView.show();

            // Display the side panel presenting information about the selected roof, if required
            if (_this._config.displayRoofPanel) {
                _this._updateRoofPanelInfos(featureInfos.address);
                _this._roofPanelView.show();
            }

            // Send an event to inform the main controller about the space which will be occupied by the panel after it
            // has completely expanded
            var reservedSpace = _this._mainPanelView.reservedMapSpace();
            if (_this._config.displayRoofPanel) {
                reservedSpace[2] = Math.max(reservedSpace[2], _this._roofPanelView.getDimensions()[1]);
            }
            am.eventManager.trigger('info_panel_visible', {
                reservedSpace: reservedSpace,
                featureBounds: featureInfos.buildingBounds,
                featureCenter: featureInfos.pointLocation
            });
        });
    };

    module.InfoPanelController.prototype._updateSlider = function(updateResults, optimizePanelSurface, results) {
        var self = this;
        updateResults = (updateResults === undefined) ? true : updateResults;
        optimizePanelSurface = (optimizePanelSurface === undefined) ? true : optimizePanelSurface;
        if (results) {
            // Set the slider range
            self._mainPanelView.options.pvPanelYield = results.pvPanelYield;
            self._mainPanelView.setSliderRange(6, results.maxAvailableRoof3DArea);

            // Update the results if required
            if (updateResults) {
                var userInputs = self._mainPanelView.getUserInputs();
                if (optimizePanelSurface) {
                    userInputs.usedRoofArea = results.optimalSurfaceForElectricitySale;
                    self._mainPanelView.setSliderValue(userInputs.usedRoofArea); // set the slider to the optimal surface
                }
            }
        }
    };

    module.InfoPanelController.prototype._updateRoofPanelInfos = function(address) {
        var self = this;
        this._address = address;

        if (this._config.displayRoofPanel) {
            var $container = $(self._roofPanelView.getContainer());

            am.templateManager.getTemplateAsHTMLElements('small-side-panel', {
                irradiationClasses : self._irradiationClasses,
                address: address,
                displayPublicFooter: false,
                compactForm: true
            }).then(function(htmlElements) {
                self._roofPanelView.setContents(htmlElements[0]);
                am.utils.colorSolarPotentialDivs($container, "to top", self._irradiationClasses);
                am.utils.updateSolarPotentialDivs($container, true);
            });
        }
    };

    module.InfoPanelController.prototype._updateResults = function() {
        var _this = this;

        var userInputs = this._mainPanelView.getUserInputs();
        var currPeakPower = userInputs.usedRoofArea * this._mainPanelView.options.pvPanelYield;
        if (currPeakPower >= this._config.maxAllowedInstallationPower) {
            $(".show-if-above-100-kWc").removeClass("hidden");
            $(".hide-if-above-100-kWc").addClass("hidden");
        } else {
            $(".show-if-above-100-kWc").addClass("hidden");
            $(".hide-if-above-100-kWc").removeClass("hidden");
        }

        return new Promise(function(resolve, reject) {
            am.solarInstallationModel.setUserInfos(userInputs).then(function() {
                return am.solarInstallationModel.getResults();
            }).then(function(results) {
                resolve(results);
            });
        }).then(function(_results) {
            _this._mainPanelView.setComputationResults(_results, _this._dataBindings);
            return _results;
        });
    };

    module.InfoPanelController.prototype._hideFeatureInfo = function() {
        // Send an event to inform the main controller about the space which will be freed by the panel after it
        // has been completely hidden
        am.eventManager.trigger('info_panel_hidden', {
            reservedSpace: this._mainPanelView.reservedMapSpace()
        });

        // Hide the panel
        this._mainPanelView.hide();
        if (this._config.displayRoofPanel) {
            this._roofPanelView.hide();
        }
    };

    module.InfoPanelController.prototype._getPageUrl = function(oldPageId, newPageId) {
        var urlComponents = this._mainPanelView.getUserInputs();
        if (oldPageId && newPageId) {
            urlComponents.panelPageId = newPageId;
            urlComponents.previousPanelPageId = oldPageId;
        }
        return urlComponents;
    };

    module.InfoPanelController.prototype._handleComputationStart = function(roofSurface) {
        // Display progress information only for large roofs
        if (roofSurface >= this._config.minRoofSurfaceForWaitingModal) {
            // $('.am-irradiation-computation-in-progress').show();
        }
    };

    module.InfoPanelController.prototype._handleComputationEnd = function() {
        $('.am-irradiation-computation-in-progress').hide();
    };

    module.InfoPanelController.prototype._setAddress = function(address) {
        this._address = address;
    };

    return module;

})(am || {});


//=============================================
// AM.UTILS NAMESPACE
//=============================================
am.utils = (function(module) {

    // Use strict mode
    'use strict';

    /**
     * Returns a new instance of class am.InfoPanelController
     *
     * @param {Object} mainController - Reference to the main controller of the application
     * @param {Object} config - Configuration object to be passed to the constructor of class am.InfoPanelController
     * @return {am.InfoPanelController} - New instance of class am.InfoPanelController 
     */
    module.infoPanelController = function(mainController, config) {
        var ctrl = new am.InfoPanelController();
        ctrl.init(mainController, config);
        return ctrl;
    };

    return module;

})(am.utils || {});